export const getCountryCode = (code: string) => code.split('-')[1] || '';
